import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '../core/environment/environment.service';
import { throwError } from 'rxjs';
import { AuthService } from '@app/core/auth/auth.service';
import { SessionService } from '@app/core/session/session.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/environment/environment.service";
import * as i3 from "../core/auth/auth.service";
import * as i4 from "../core/session/session.service";
var BrokerageFeeService = /** @class */ (function () {
    function BrokerageFeeService(http, environmentService, authService, sessionService) {
        var _this = this;
        this.http = http;
        this.environmentService = environmentService;
        this.authService = authService;
        this.sessionService = sessionService;
        this.currentGestorDemanda = null;
        this.serviceUrl = '/brokeragefee';
        this.jwt = this.sessionService.retrieveToken();
        this.statusRquest = true;
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlBrokerageFee;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    }
    BrokerageFeeService.prototype.updateBrokerageFeeList = function (applyList, parameters) {
        var ret;
        var endpointPagination = '/taxas_corretagem';
        var url = "" + this.apiUrl + this.serviceUrl + endpointPagination;
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/taxas_corretagem';
        var bodyObj = JSON.stringify(applyList);
        ret = this.http.post(url, bodyObj, {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('Access-Control-Allow-Headers', 'x-jwt')
                .set("x-jwt", parameters.jwt.trim()),
            observe: 'response'
        });
        return ret;
    };
    //Chamada de serviço do back end para preenchimento de grid
    //api/brokeragefee-service/brokeragefee/taxas_corretagem_boletas
    BrokerageFeeService.prototype.getBrokerageFeeList = function (parameters) {
        if (parameters !== undefined) {
            var url;
            var queryParams = '';
            var endpointPagination = '/taxas_corretagem_boletas?';
            var ret;
            queryParams += 'page=' + (parameters.pageIndex.toString());
            queryParams += '&page_size=' + (parameters.pageSize.toString());
            queryParams += '&carteira=' + encodeURIComponent(parameters.carteira.toString().trim().length === 0 ? '' : parameters.carteira.toString());
            queryParams += '&data_inicio_negociacao=' + encodeURIComponent(parameters.data_inicio_negociacao === null ? '' : parameters.data_inicio_negociacao.toLocaleString('pt-BR'));
            queryParams += '&data_fim_negociacao=' + encodeURIComponent(parameters.data_fim_negociacao === null ? '' : parameters.data_fim_negociacao.toLocaleString('pt-BR'));
            queryParams += '&modalidade=' + encodeURIComponent(parameters.modalidade.length === 0 ? '' : parameters.modalidade.join(','));
            queryParams += '&corretora=' + encodeURIComponent(parameters.corretora.toString().trim().length === 0 ? '' : parameters.corretora.toString());
            queryParams += '&papel=' + encodeURIComponent(parameters.papel.toString().trim().length === 0 ? '' : parameters.papel.toString());
            queryParams += '&status=' + encodeURIComponent(parameters.status.length === 0 ? '' : parameters.status.join(','));
            url = "" + this.apiUrl + this.serviceUrl + endpointPagination + queryParams;
            //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee' + `${endpointPagination}${queryParams}`
            ret = this.http.get(url, {
                headers: new HttpHeaders()
                    .set("x-jwt", parameters.jwt.trim())
                    .set('Content-Type', 'application/json'),
                observe: 'response'
            });
            return ret;
        }
    };
    //Chamada de serviço do Back end para export Excel e PDF
    //api/brokeragefee-service/brokeragefee/taxas_corretagem/binario
    BrokerageFeeService.prototype.getBrokerageFeeExport = function (parameters) {
        if (parameters !== undefined) {
            var url = '';
            var queryParams = '';
            var endpointPagination = '/taxas_corretagem/binario?';
            var ret;
            queryParams += 'carteira=' + encodeURIComponent(parameters.carteira.toString().trim().length === 0 ? '' : parameters.carteira.toString());
            queryParams += '&data_inicio_negociacao=' + encodeURIComponent(parameters.data_inicio_negociacao === null ? '' : parameters.data_inicio_negociacao.toLocaleString('pt-BR'));
            queryParams += '&data_fim_negociacao=' + encodeURIComponent(parameters.data_fim_negociacao === null ? '' : parameters.data_fim_negociacao.toLocaleString('pt-BR'));
            queryParams += '&modalidade=' + encodeURIComponent(parameters.modalidade.length === 0 ? '' : parameters.modalidade.join(','));
            queryParams += '&corretora=' + encodeURIComponent(parameters.corretora.toString().trim().length === 0 ? '' : parameters.corretora.toString());
            queryParams += '&papel=' + encodeURIComponent(parameters.papel.toString().trim().length === 0 ? '' : parameters.papel.toString());
            queryParams += '&status=' + encodeURIComponent(parameters.status.length === 0 ? '' : parameters.status.join(','));
            url = "" + this.apiUrl + this.serviceUrl + endpointPagination + queryParams;
            //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee' + `${endpointPagination}${queryParams}`
            ret = this.http.get(url, {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
                    .set("x-jwt", parameters.jwt.trim()),
                observe: 'response'
            });
            return ret;
        } //[]
    };
    //Chamada de serviço do back end para preenchimento de combo box
    //api/brokeragefee-service/brokeragefee/Status
    BrokerageFeeService.prototype.getStatus = function (parameters) {
        var endpointPagination = '/status_taxas_corretagem';
        var newToken;
        var url = "" + this.apiUrl + this.serviceUrl + endpointPagination + '?ativo=true';
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/status_taxas_corretagem?ativo=true';
        return this.http.get(url, {
            headers: new HttpHeaders()
                .set("x-jwt", parameters.jwt.trim())
                .set('Content-Type', 'application/json'),
            observe: 'response'
        });
    };
    BrokerageFeeService.prototype.getWorkTime = function (parameters) {
        var endpointPagination = '/taxas_corretagem/horario_limite';
        var newToken;
        var url = "" + this.apiUrl + this.serviceUrl + endpointPagination;
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/taxas_corretagem/horario_limite';
        return this.http.get(url, {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set("x-jwt", parameters.jwt.trim()),
            observe: 'response'
        });
    };
    //Repassa o resultado para um array
    BrokerageFeeService.prototype.jsonDataToComboboxStatuss = function (jsonData) {
        var _this = this;
        var items = [];
        if (jsonData && Array.isArray(jsonData)) {
            jsonData.forEach(function (element) {
                var el = element;
                el.nome_status_taxa_corretagem = _this.ChangeLang(el.codigo_status_taxa_corretagem);
                items.push(el);
            });
        }
        return items;
    };
    BrokerageFeeService.prototype.ChangeLang = function (cod) {
        var lang = localStorage.getItem('lang') === 'br' ? 'pt-BR' : 'en-US';
        var retorno = '';
        switch (cod) {
            case 1: {
                if (lang === 'pt-BR') {
                    retorno = 'Aprovado';
                }
                else {
                    retorno = 'Approved';
                }
                break;
            }
            case 2: {
                if (lang === 'pt-BR') {
                    retorno = 'Reprovado';
                }
                else {
                    retorno = 'Reproved';
                }
                break;
            }
            case 3: {
                if (lang === 'pt-BR') {
                    retorno = 'Inconsitente';
                }
                else {
                    retorno = 'Unmatched';
                }
                break;
            }
            case 5: {
                if (lang === 'pt-BR') {
                    retorno = 'Consistente';
                }
                else {
                    retorno = 'Matched';
                }
                break;
            }
            default: {
                retorno = '';
                break;
            }
        }
        return retorno;
    };
    //Repassa o Access Token
    BrokerageFeeService.prototype.setToken = function (newToken) {
        if (newToken && newToken != '') {
            this.jwt = newToken;
            this.sessionService.setToken(newToken);
        }
    };
    BrokerageFeeService.prototype.handleError = function (error) {
        this.statusRquest = false;
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError('Erro ao enviar demanda.');
    };
    BrokerageFeeService.ngInjectableDef = i0.defineInjectable({ factory: function BrokerageFeeService_Factory() { return new BrokerageFeeService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.AuthService), i0.inject(i4.SessionService)); }, token: BrokerageFeeService, providedIn: "root" });
    return BrokerageFeeService;
}());
export { BrokerageFeeService };
